// extracted by mini-css-extract-plugin
export default {"mainBlock":"Main_mainBlock__O0895","imgBlock":"Main_imgBlock__ZjIhP","mainImg":"Main_mainImg__NT4kw","text":"Main_text__sXxLq"};